---
headline: Studio.
---

## Practice

Brian Ellison founded BED in 2017 to pursue a practice grounded in **craft, restraint, and place**. The studio works with private clients and select commercial and hospitality partners to shape spaces of lasting quality.

Projects range from coastal residences to boutique restaurants, multifamily lobbies, and one-of-a-kind retail interiors. Each begins with extended conversation, site study, and a deliberately slow concept phase before any drawings are produced.

## Philosophy

BED's work foregrounds **materials as language**. Stone, plaster, wood, brass, lacquer, and linen each carry meaning; their combinations carry voice. The studio resists trend-driven decoration in favor of compositions that gain depth over time.

Light is treated as architecture — daylight directed, layered, and softened; electric light specified with the precision of a recording engineer.

## Recognition

- *Best of Houzz, Design — 2025*
- *Recommended on Houzz*
- *250+ Ideabook saves on Houzz*
- Featured projects across Brevard County

## Process

1. **Listening** — extended initial conversations to understand the client, the site, and the way of living the space must support.
2. **Concept** — material studies, light studies, proportion sketches. Months, not weeks.
3. **Design Development** — drawings, specifications, finish samples, fixture sourcing, and pricing alignment.
4. **Documentation** — construction drawings, schedules, and procurement coordination with trades.
5. **Construction Administration** — site visits, finish review, and trade coordination through completion.
6. **Styling** — final styling and photography, optional but encouraged.

## Studio details

Based in **Melbourne, Florida**, with active projects throughout Brevard County and select projects further afield. Studio visits by appointment.
